/// <amd-module name="SuiteCommerce.PagePrinter.ExtQRCode.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.PagePrinter.ExtQRCode.View", ["require", "exports", "Backbone", "SuiteCommerce.PagePrinter.ExtQRCode.Model", "sc_ext_qr_code.tpl", "SuiteCommerce.PagePrinter.ExtQRCode.Utils"], function (require, exports, Backbone_1, QRCode_Model_1, qrcodeTemplate, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var QRCodeView = /** @class */ (function (_super) {
        __extends(QRCodeView, _super);
        function QRCodeView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = qrcodeTemplate;
            _this.DEFAULT_WIDTH = '100px';
            _this.DEFAULT_HEIGHT = '100px';
            _this.DEFAULT_SECONDARY_COLOR = '#ffffff';
            _this.DEFAULT_PRIMARY_COLOR = '#000000';
            _this.DEFAULT_CORRECTION_LEVEL = Utils_1.QRCorrectionLevel.H;
            _this.placeholderData = options;
            return _this;
        }
        QRCodeView.prototype.getContext = function () {
            var textToEncode = this.getDataForEncoding();
            if (textToEncode) {
                try {
                    this.prepareQRCodeData(textToEncode);
                    return {
                        qrId: new Date().getUTCMilliseconds(),
                        renderCode: true,
                        textToEncode: textToEncode,
                        moduleQuantity: this.model.getModuleQuantity(),
                        defaultModules: this.getDefaultModules(),
                        width: this.placeholderData.width || this.DEFAULT_WIDTH,
                        height: this.placeholderData.height || this.DEFAULT_HEIGHT,
                        secondaryColor: this.placeholderData.secondaryColor || this.DEFAULT_SECONDARY_COLOR,
                        primaryColor: this.placeholderData.primaryColor || this.DEFAULT_PRIMARY_COLOR,
                    };
                }
                catch (e) {
                    console.warn(e.message);
                }
            }
            else {
                console.warn('You need to specify a text to encode');
            }
            return {
                renderCode: false,
                textToEncode: textToEncode,
                showTextWhenFails: this.placeholderData.showTextWhenFails,
            };
        };
        QRCodeView.prototype.prepareQRCodeData = function (textToEncode) {
            var correctionLevel = this.getCorrectionLevel();
            var type = this.getQRType(textToEncode, correctionLevel);
            this.model = new QRCode_Model_1.QRCodeModel({
                type: type,
                errorCorrectLevel: correctionLevel,
                data: textToEncode,
            });
        };
        QRCodeView.prototype.getCorrectionLevel = function () {
            return ((Utils_1.QRCorrectionLevel[this.placeholderData.correctionlevel]) || this.DEFAULT_CORRECTION_LEVEL);
        };
        QRCodeView.prototype.getQRType = function (data, nCorrectLevel) {
            var type = 1;
            var length = this.getUTF8Length(data);
            for (var i = 0; i <= Utils_1.QRCodeLimitLength.length; i++) {
                var limit = 0;
                switch (nCorrectLevel) {
                    case Utils_1.QRCorrectionLevel.L:
                        limit = Utils_1.QRCodeLimitLength[i][0];
                        break;
                    case Utils_1.QRCorrectionLevel.M:
                        limit = Utils_1.QRCodeLimitLength[i][1];
                        break;
                    case Utils_1.QRCorrectionLevel.Q:
                        limit = Utils_1.QRCodeLimitLength[i][2];
                        break;
                    case Utils_1.QRCorrectionLevel.H:
                        limit = Utils_1.QRCodeLimitLength[i][3];
                        break;
                }
                if (length <= limit) {
                    break;
                }
                else {
                    type++;
                }
            }
            if (type > Utils_1.QRCodeLimitLength.length) {
                throw new Error('Too long data');
            }
            return type;
        };
        QRCodeView.prototype.getUTF8Length = function (data) {
            var replacedText = encodeURI(data)
                .toString()
                .replace(/\%[0-9a-fA-F]{2}/g, 'a');
            return replacedText.length + (replacedText.length !== data.length ? 3 : 0);
        };
        QRCodeView.prototype.getDataForEncoding = function () {
            return this.placeholderData.encode;
        };
        QRCodeView.prototype.getDefaultModules = function () {
            var defaultModules = [];
            var moduleQuantity = this.model.getModuleQuantity();
            for (var row = 0; row < moduleQuantity; row++) {
                for (var col = 0; col < moduleQuantity; col++) {
                    if (this.model.isDarkBlock(row, col)) {
                        defaultModules.push({ col: col, row: row });
                    }
                }
            }
            return defaultModules;
        };
        return QRCodeView;
    }(Backbone_1.View));
    exports.QRCodeView = QRCodeView;
});
